import type { NodeBase, NodeBaseItem } from '../../../entities/Node';
import { withSearchResults } from '../../../components/Tree/helpers/helpers';
import { ReadOnlyArray } from '../../../utils/array/ReadOnlyArray';

interface ClearSearchResult {
  searchCondition: null;
  searchFocusId: null;
  searchFocusIndex: null;
  searchMatches: NodeBaseItem[];
  searchSuggestions: { id: string; title: string; type: string; data: unknown }[];
  searchQuery: null;
  treeData: NodeBase[];
}

export function clearSearch(treeData: NodeBase[] = []): ClearSearchResult {
  const searchFocusId = null;
  const searchFocusIndex = null;
  const searchMatches = ReadOnlyArray.Empty as NodeBaseItem[];

  return {
    searchCondition: null,
    searchFocusId,
    searchFocusIndex,
    searchMatches,
    searchSuggestions: ReadOnlyArray.Empty as {
      id: string;
      title: string;
      type: string;
      data: unknown;
    }[],
    searchQuery: null,
    treeData: withSearchResults({
      treeData,
      searchMatches,
      searchFocusId,
      expandMatches: false,
    }),
  };
}
